module.exports = __webpack_public_path__ + "static/media/arrow-down-white.80716fe7.svg";